import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../helpers/common/Box/Box";
import { Text } from "../../../Text";
import { TEXT_MIXIN_BY_BUTTON_INLINE_SIZE_MAP } from "../../constants/sizes";

import type { BoxComponentWithDefault } from "../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../types/react";
import type { TextProps } from "../../../Text";
import type { ButtonInlineSize } from "../../types";

import classes from "./ButtonInlineLabel.styl";

const BUTTON_INLINE_LABEL_TEST_ID = "button-inline-label-test-id";

type LabelProps = OmitOfUnion<
    TextProps,
    | "textCase"
    | "maxLines"
    | "underline"
    | "strikethrough"
    | "alignmentX"
    | "width"
    | "typographyStyle"
    | "lineHeight"
> & {
    size?: ButtonInlineSize;
};

export const ButtonInlineLabel = boxForwardRef<
    BoxComponentWithDefault<"span", LabelProps, "className">
>(({ typographyStyle, size, customVarsStyles, children, ...props }, ref) =>
    children ? (
        <Text
            data-tsid={BUTTON_INLINE_LABEL_TEST_ID}
            {...props}
            typographyStyle={
                typographyStyle ||
                (size && TEXT_MIXIN_BY_BUTTON_INLINE_SIZE_MAP[size])
            }
            maxLines={1}
            customVarsStyles={cn(
                classes["custom-vars-styles"],
                customVarsStyles,
            )}
            ref={ref}
        >
            {children}
        </Text>
    ) : null,
);

ButtonInlineLabel.displayName = "ButtonInline.Label";

export default ButtonInlineLabel;
